import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import Loading from "./Components/Loading";
import Mensagem from "./Components/Mensagem";
import { LoadProvider } from "./context";
import "./index.css";
import Rotas from "./Routes";
import ScrollToTop from "./Components/PaginaIniciaNoTopo";
import logoWhatsapp from "./assets/images/pngs/logoWhatsapp.png";
import logoWhatsappMobile from "./assets/images/pngs/logoWhatsappMobile.png";

const whatsappMessage = "Olá! Estou aqui no site e preciso de ajuda no Amigo Leo";
const whatsappLink = `https://api.whatsapp.com/send?phone=5508005910127&text=${encodeURIComponent(
  whatsappMessage
)}`;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <LoadProvider>
      <BrowserRouter>
        <ScrollToTop>
          <Loading />
          <Mensagem />
          <Rotas />
          <a
            className="whatsapp-atendimento"
            href={whatsappLink}
            target="_blank"
            rel="noreferrer"
            aria-label="Fale com um atendente pelo WhatsApp"
          >
            <picture>
              <source media="(max-width: 768px)" srcSet={logoWhatsappMobile} />
              <img src={logoWhatsapp} alt="WhatsApp" />
            </picture>
          </a>
        </ScrollToTop>
      </BrowserRouter>
    </LoadProvider>
  </>
);
